// extracted by mini-css-extract-plugin
export default {"container":"IsNewTemplate_container__LS0AH","button":"IsNewTemplate_button__xZdYF","new":"IsNewTemplate_new__9SXMP","old":"IsNewTemplate_old__EBKuu"};